import * as React from 'react';

import { NameGetter } from '../types/props';

import { defaultGetter } from './default-getter';

import { GetKeysByType } from '@common/typescript/utils/types';

import { SelectList } from '@app/store/SelectList/SelectList';
import { EntityType } from '@app/store/SelectList/UtilityTypes';

export function getName<TStore extends keyof SelectList>(
	item: EntityType<TStore>,
	getter: NameGetter<EntityType<TStore>> = defaultGetter,
): React.ReactNode {
	if (typeof getter === 'function') return getter(item);
	const record: Record<GetKeysByType<EntityType<TStore>, string>, string> = item as Record<GetKeysByType<EntityType<TStore>, string>, string>;

	return record[getter];
}
